<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">运营员新增</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label" require>用户名</div>
            <label>
              <input
                type="text"
                class="cg-input"
                v-model="form.username"
                @input="
                  form.username = form.username.replace(/[\u4e00-\u9fa5]/g, '')
                "
              />
            </label>
          </div>
          <div class="item col-1">
            <div class="label" require>密码</div>
            <label
              ><input type="text" class="cg-input" v-model="form.userpwd"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label" require>岗位</div>
            <el-select
              v-model="form.gw"
              placeholder="请选择岗位"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in gangwei"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="item col-1">
            <div class="label" require>名称</div>
            <label
              ><input type="text" class="cg-input" v-model="form.name"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label" require @input="phoneValid('form', 'phone')">
              手机号
            </div>
            <label
              ><input
                type="text"
                class="cg-input"
                v-model="form.phone"
                maxlength="11"
            /></label>
          </div>
        </div>
      </div>
      <div class="form-options">
        <el-button class="publish-btn" size="small" @click="addUser"
          >新增</el-button
        >
      </div>
    </div>
    <el-table
      :data="users"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="username" label="用户名" />
      <el-table-column align="center" prop="position" label="岗位" />
      <el-table-column align="center" prop="nickname" label="名称" />
      <el-table-column align="center" prop="phone" label="手机号" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label" require>用户名</span>
          <label
            ><input
              type="text"
              class="cg-input"
              v-model="upname"
              @input="upname = upname.replace(/[\u4e00-\u9fa5]/g, '')"
          /></label>
        </div>
        <div class="item">
          <span class="label">密码</span>
          <label
            ><input
              type="text"
              class="cg-input"
              v-model="uppass"
              placeholder="修改密码时须填"
          /></label>
        </div>
        <div class="item">
          <span class="label" require>岗位</span>
          <el-select
            size="mini"
            class="cg-input"
            filterable
            v-model="upgw"
            placeholder="请选择岗位"
            style="padding: 4px 0"
          >
            <el-option
              v-for="item in gangwei"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="label" require>名称</span>
          <label><input type="text" class="cg-input" v-model="upming" /></label>
        </div>
        <div class="item">
          <span class="label" require @input="phoneValid('form', 'phone')"
            >手机号</span
          >
          <label><input type="text" class="cg-input" v-model="uphone" /></label>
        </div>
        <div class="footer">
          <el-button class="publish-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
const { proxy } = getCurrentInstance();

// 弹窗字段
const upname = ref("");
const upgw = ref("");
const uppass = ref("");
const upming = ref("");
const uphone = ref("");
const upid = ref("");

const form = reactive({
  username: "", // 用户名
  userpwd: "", // 密码
  phone: "", // 手机号
  name: "", // 名称
  gw: "", //岗位
});

const dialogTableVisible = ref(false); //弹窗控制
const users = ref([]); // 用户列表
const gangwei = ref([
  { id: 1, name: "技术开发" },
  { id: 2, name: "运营管理" },
  { id: 3, name: "测试员" },
]);

// 保存草稿
const saveDraft = () => {
  const draft = {
    form: form,
  };
  sessionStorage.setItem("operUserDraft", JSON.stringify(draft));
};

// 读取草稿回填
const loadDraft = () => {
  const str = sessionStorage.getItem("operUserDraft");
  if (str) {
    try {
      const draft = JSON.parse(str);
      Object.assign(
        form,
        draft.form || {
          username: "",
          userpwd: "",
          phone: "",
          name: "",
          gw: "",
        }
      );
    } catch (e) {
      sessionStorage.removeItem("operUserDraft");
    }
  }
};

// 清空草稿
const clearDraft = () => {
  sessionStorage.removeItem("operUserDraft");
};

const save = async () => {
  if (!upname.value.trim()) {
    proxy.$message.error("用户名必填");
    return false;
  }
  if (!upgw.value) {
    proxy.$message.error("岗位必填");
    return false;
  }
  if (!upming.value.trim()) {
    proxy.$message.error("名称必填");
    return false;
  }
  if (!uphone.value.trim()) {
    proxy.$message.error("手机号必填");
    return false;
  }
  if (uphone.value.trim().length < 11) {
    proxy.$message.error("请输入完整的手机号");
    return false;
  }
  console.log(upgw.value, "拿到了什么");
  let gwname = "";
  if (upgw.value && typeof upgw.value === "string") {
    gwname = gangwei.value.filter((i) => i.name == upgw.value);
  } else {
    gwname = gangwei.value.filter((i) => i.id == upgw.value);
  }
  const sendata = {
    id: upid.value, //运营员id
    username: upname.value, //用户名
    nickname: upming.value, //名称
    phone: uphone.value, //电话
    position: gwname[0].name, //岗位
  };
  if (uppass.value !== "") {
    sendata.password = uppass.value; //密码
  }
  console.log(sendata, "传的参数对不对");
  const res = await proxy.$api.Operation.UserSet.update(sendata);
  if (res.data.code == 200) {
    dialogTableVisible.value = false;
    proxy.$message.success("修改成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
  }
};

const up = (row) => {
  console.log(row, "拿到的是不是当行数据");
  uppass.value = "";
  upname.value = row.username;
  uphone.value = row.phone;
  upgw.value = row.position;
  upming.value = row.nickname;
  upid.value = row.id;
  dialogTableVisible.value = true;
};

// 限制手机号只能输入数字
const phoneValid = (parent, key) => {
  form[parent][key] = form[parent][key].replace(/[^0-9]/g, "");
};

const getList = async () => {
  console.log(proxy.$store.getters.userInfo.id, form.gw, "vuex存储了什么");
  const sendata = {
    urrentPage: 1, //当前页
    pageSize: 50, //每页大小
    id: "", //运营员id
    username: form.username, //用户名
    nickname: form.name, //名称
    phone: form.phone, //电话
    position: form.gw, //岗位
  };
  const res = await proxy.$api.Operation.UserSet.get(sendata);
  console.log(res.data.code);
  if (res.data.code == 200) {
    users.value = res.data.data.list;
    console.log(users.value, "返回的列表是什么格式");
  } else {
    proxy.$message.error("网络错误");
    users.value = [];
  }
};

const addUser = async () => {
  if (!form.username.trim()) {
    proxy.$message.error("用户名必填");
    return false;
  }
  if (!form.userpwd.trim()) {
    proxy.$message.error("密码必填");
    return false;
  }
  if (!form.gw) {
    proxy.$message.error("岗位必填");
    return false;
  }
  if (!form.name.trim()) {
    proxy.$message.error("名称必填");
    return false;
  }
  if (!form.phone.trim()) {
    proxy.$message.error("手机号必填");
    return false;
  }
  if (form.phone.trim().length < 11) {
    proxy.$message.error("请输入完整的手机号");
    return false;
  }
  const gwname = gangwei.value.filter((i) => i.id == form.gw);
  const sendata = {
    username: form.username.trim(),
    password: form.userpwd.trim(),
    nickname: form.name.trim(),
    phone: form.phone,
    position: gwname[0].name,
  };
  console.log(sendata, "看看参数是否正确");
  const res = await proxy.$api.Operation.UserSet.add(sendata);
  if (res.data.code == 200) {
    form.username = "";
    form.phone = "";
    form.name = "";
    form.gw = "";
    form.userpwd = "";
    clearDraft(); //新增成功，清除草稿缓存
    proxy.$message.success("新增成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
    form.username = "";
    form.phone = "";
    form.gw = "";
    form.userpwd = "";
    form.name = "";
  }
};

const delUser = async (id) => {
  const sendata = { id: id };
  const res = await proxy.$api.Operation.UserSet.del(sendata);
  if (res.data.code == 200) {
    form.username = "";
    form.phone = "";
    form.name = "";
    form.gw = "";
    form.userpwd = "";
    clearDraft(); //删除后也清空草稿
    proxy.$message.success("删除成功");
    getList();
  } else {
    proxy.$message.error("网络错误");
    form.username = "";
    form.phone = "";
    form.name = "";
    form.gw = "";
    form.userpwd = "";
  }
};

onMounted(() => {
  getList();
  // 页面载入，读取草稿回填表单
  loadDraft();
});

onBeforeUnmount(() => {
  // 组件销毁前保存草稿
  saveDraft();
});
</script>

<style lang="scss" scoped>
@import "./user-set";
.panel-title {
  color: #999;
}
.publish-btn {
  background-color: #ff9900;
}
</style>
